import React, { useState, useCallback, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Table, Tag } from 'antd';
import { useLocation } from 'react-router-dom';
import useApplicationSession from '../../session/UserSession';
import { getSubscription } from '../../api';
import Current from '../../components/subscription/Current';
import moment from 'moment';
const { Content } = Layout;

const SubscriptionList = ({ refNumber }) => {
    const [subscriptions, setSubscription] = useState([]);
    const token = useApplicationSession();
    const location = useLocation();
    const loadSubscription = useCallback(
        (confirmation_number) => {
            if (token) {
                getSubscription({ token, status: 'pending,approved,ordered,active' })
                    .then((response) => {
                        if (confirmation_number) {
                            // for detail
                            const detail = response.filter((data) => data.confirmation_number === confirmation_number);

                            setSubscription(detail);
                        } else {
                            // for list
                            setSubscription(response);
                        }
                    })
                    .catch((error) => {});
            }
        },
        [token]
    );

    const loadDetail = useCallback(() => {
        if (location.state && location.search === '') {
            setSubscription([location?.state]);
        }
    }, [location]);

    useEffect(() => {
        if (location.search === '') {
            const paths = location?.pathname?.split('/');

            if (paths.length === 3) {
                loadSubscription(paths[2]);
            }
            loadDetail();
        } else {
            loadSubscription();
        }
    }, [loadSubscription, loadDetail, location]);

    return (
        <Fragment>
            {subscriptions.length === 1 ? (
                <Current data={subscriptions[0]} type="active" />
            ) : (
                <Content className="subscriptionHistoryContainer">
                    <label>Current Subscription</label>
                    <Table columns={columns} dataSource={subscriptions} />
                    <div className="clearfix"></div>
                </Content>
            )}
        </Fragment>
    );
};

export default SubscriptionList;

const columns = [
    {
        title: 'Confirmation Number',
        dataIndex: 'confirmation_number',
        key: 'confirmation_number',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    {
        title: 'Vehicle',
        dataIndex: 'vehicle',
        key: 'vehicle',
        render: (vehicle) => (
            <span>
                <p style={{ fontSize: 10, fontWeight: 700 }}>{vehicle.name}</p>
                <p style={{ fontSize: 10 }}>{vehicle.license_plate_number}</p>
            </span>
        ),
    },
    {
        title: 'Period of Hire',
        // dataIndex: "period_of_hire",
        // key: "period_of_hire",
        render: (record) => {
            return (
                <span>
                    <p style={{ fontSize: 10, fontWeight: 700 }}>{`${record.period_of_hire} Months`}</p>
                    <p style={{ fontSize: 10 }}>{`${moment(record?.start_date, 'DD-MM-YYYY').format(
                        'DD MMMM YYYY'
                    )} to ${moment(record?.end_date, 'DD-MM-YYYY').format('DD MMMM YYYY')}`}</p>
                </span>
            );
        },
    },
    {
        title: 'Next Payment',
        dataIndex: 'next_payment',
        key: 'next_payment',
        render: (text) => <p style={{ fontSize: 10 }}>{`${moment(text, 'DD-MM-YYYY').format('DD MMMM YYYY')}`}</p>,
    },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        render: (text) => (
            <span>
                <Tag color={getTagColor(text)} style={{ fontSize: 10 }}>
                    {text}
                </Tag>
            </span>
        ),
    },
    {
        title: 'Action',
        key: 'action',
        render: (record) => {
            return (
                <span>
                    <Link
                        // target="_blank"
                        style={{ fontSize: 10, padding: 5 }}
                        to={{
                            pathname: `/subscriptions/${record.confirmation_number}`,
                            // search: `?ref=${record.confirmation_number}`,
                            state: record,
                        }}
                    >
                        Detail
                    </Link>
                    {/* <a style={{ fontSize: 10 }}>Invoice</a> */}
                </span>
            );
        },
    },
];

const getTagColor = (type) => {
    switch (type) {
        case 'pending':
            return 'orange';
        case 'approved':
            return 'green';
        case 'active':
            return 'green';
        default:
            break;
    }
};
